import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher, sync_command_dispatcher } from "@/api/client";
import { ExtraUserContractPopupRepository } from "../domain/ExtraUserContractPopupRepository";

export class ApiExtraUserContractPopupRepository implements ExtraUserContractPopupRepository {
    query_dispatcher: QueryDispatcher;
    sync_command_dispatcher: CommandDispatcher;

    constructor() {
        this.query_dispatcher = query_dispatcher;
        this.sync_command_dispatcher = sync_command_dispatcher;
    }

    async getUserTax(args: object): Promise<any> {
        try {
            return await this.query_dispatcher.dispatch("get.user.tax", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async rememberUsedCard(args: object): Promise<any> {
        try {
            return await this.query_dispatcher.dispatch("retrieve.stripe.payment.method", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async purchaseExtraUsers(args: object): Promise<any> {
        try {
            return await this.sync_command_dispatcher.dispatch("purchase.extra.users", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async payWithOldCard(args: object): Promise<any> {
        try {
            return await this.sync_command_dispatcher.dispatch("create.stripe.payment.intent.for.extra.users", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async payWithNewCard(args: object): Promise<any> {
        try {
            return await this.sync_command_dispatcher.dispatch("create.stripe.session.for.buy.extra.users", args);
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}